// Retailer portal — entry point.
//
// All real wiring lives in src/shell/shell.ts. This file just locates the
// root element and hands off.

import "@tkos/shared-ui/tokens.css";
import { mount } from "./shell/shell";
import { installResumeBanner } from "./pages/quote-builder/resume-banner";

const root = document.getElementById("app");
if (!root) {
  throw new Error("Missing #app root element in index.html");
}

void mount(root);
installResumeBanner();

// Register the service worker for production. In dev (Vite, port 3100
// via dev.tkos.io proxy) we *unregister* any pre-existing SW so HMR
// updates aren't masked by stale cached bundles — the SW used to ship
// out-of-date JS to retailers reloading the page during a deploy.
if ("serviceWorker" in navigator) {
  const isDev = import.meta.env.DEV || /(^|\.)(dev|stage)\./.test(location.hostname);
  window.addEventListener("load", () => {
    if (isDev) {
      void navigator.serviceWorker
        .getRegistrations()
        .then((regs) => Promise.all(regs.map((r) => r.unregister())))
        .then(() => {
          // Best-effort: drop any cached responses too.
          if ("caches" in window) {
            return caches.keys().then((keys) =>
              Promise.all(keys.map((k) => caches.delete(k))),
            );
          }
          return undefined;
        })
        .catch(() => undefined);
    } else {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.warn("[sw] registration failed:", err);
      });
    }
  });
}
